import React from "react"
import { WorkflowNode, WorkflowNodeData } from "lib/types/workflow"
import { useAppDispatch } from "lib/store"
import { hideEditSidebar } from "lib/store/services/editSidebar/slice"

import EditSidebar from "components/Ui/EditSidebar/EditSidebar"
import EditSideBarHeader from "components/Ui/EditSidebar/EditSidebarHeader"
import { DeleteNodeButton, ReadOnlyFieldset } from "./NodeEditorSidebar.styled"
import TriggerNodeForm from "./TriggerNodeForm"
import ConditionNodeForm from "./ConditionNodeForm"
import ActionNodeForm from "./ActionNodeForm"

type Props = {
  selectedNode: WorkflowNode | null
  onSave: (nodeId: string, data: WorkflowNodeData) => void
  onDelete: (nodeId: string) => void
  readOnly?: boolean
}

const NodeEditorSidebar = ({ selectedNode, onSave, onDelete, readOnly = false }: Props) => {
  const dispatch = useAppDispatch()

  if (!selectedNode) return null

  const nodeType = selectedNode.data.nodeType
  const title =
    nodeType === "TRIGGER"
      ? readOnly ? "Trigger" : "Edit Trigger"
      : nodeType === "CONDITION"
        ? readOnly ? "Condition" : "Edit Condition"
        : readOnly ? "Action" : "Edit Action"

  const handleClose = () => {
    dispatch(hideEditSidebar())
  }

  const form = (
    <>
      {nodeType === "TRIGGER" && (
        <TriggerNodeForm node={selectedNode} onSave={onSave} hideSave={readOnly} />
      )}
      {nodeType === "CONDITION" && (
        <ConditionNodeForm node={selectedNode} onSave={onSave} hideSave={readOnly} />
      )}
      {nodeType === "ACTION" && (
        <ActionNodeForm node={selectedNode} onSave={onSave} hideSave={readOnly} />
      )}
    </>
  )

  return (
    <EditSidebar cancelEvent={handleClose}>
      <EditSideBarHeader title={title} cancelEvent={handleClose}>
        {!readOnly && nodeType !== "TRIGGER" && (
          <DeleteNodeButton
            type="button"
            onClick={() => {
              onDelete(selectedNode.id)
              handleClose()
            }}
          >
            Delete Node
          </DeleteNodeButton>
        )}
      </EditSideBarHeader>
      {readOnly ? <ReadOnlyFieldset disabled>{form}</ReadOnlyFieldset> : form}
    </EditSidebar>
  )
}

export default NodeEditorSidebar
